import TwitterIcon from "../assets/icons/twitter.svg";
import LinkedinIcon from "../assets/icons/linkedin.svg";
import InstagramIcon from "../assets/icons/instagram.svg";

export const socials = [
  {
    title: "توییتر",
    icon: TwitterIcon,
    link: "https://x.com/bodybon_info",
  },
  {
    title: "اینستاگرام",
    icon: InstagramIcon,
    link: "https://www.instagram.com/bodybon_info/",
  },
  {
    title: "لینکدین",
    icon: LinkedinIcon,
    link: "https://www.linkedin.com/company/bodybon-info/",
  },
];
